export const isPositiveNumericField = (event: KeyboardEvent): boolean => {
	// biome-ignore lint/performance/useTopLevelRegex: <explanation>
	const pattern = /^([0-9])$/;
	const result = pattern.test(event.key);
	return result;
};

/**
 * Stops the user from typing a dot, comma, plus, minus, or "e" in a number box
 * that should only take whole numbers.
 */
export const blockNonWholeNumberKeys = (event: KeyboardEvent): void => {
	if (['.', ',', '-', '+', 'e', 'E'].includes(event.key)) {
		event.preventDefault();
	}
};
